import React, { type JSX } from 'react';

import VideoIcon from '@rover/icons/svg/video.svg';
import { Flex, Text } from '@rover/kibble/core';
import useTheme from '@rover/kibble/themes/useTheme';
import { TextSizes } from '@rover/kibble/tokens/build/rover/es6/theme';

interface VirtualOnlyBadgeIconProps {
  iconSize?: string;
}

export function VirtualOnlyBadgeIcon({
  iconSize = '16px',
}: VirtualOnlyBadgeIconProps): JSX.Element {
  const { colors } = useTheme();

  return <VideoIcon width={iconSize} height={iconSize} fill={colors.orange[700]} />;
}

interface VirtualOnlyBadgeTextProps {
  fontSize?: TextSizes;
}

export function VirtualOnlyBadgeText({ fontSize = '200' }: VirtualOnlyBadgeTextProps): JSX.Element {
  const { colors } = useTheme();

  return (
    <Text fontWeight="semibold" sx={{ color: colors.orange[700] }} size={fontSize}>
      {/* TODO (DEV-104195): Translate below text after training pilot launch */}
      Virtual
    </Text>
  );
}

interface VirtualOnlyBadgeProps {
  fontSize?: TextSizes;
}

export default function VirtualOnlyBadge({ fontSize = '200' }: VirtualOnlyBadgeProps): JSX.Element {
  return (
    <Flex alignItems="center" gap="2x">
      <VirtualOnlyBadgeIcon />
      <VirtualOnlyBadgeText fontSize={fontSize} />
    </Flex>
  );
}
